import { fetchApi } from '@/config/axiosSetting.ts';
import { DamagesInformationQuery } from '@/modules/FileDetail/queries/damagesInformation/damagesInformationQuery.type.ts';

export const damagesInformationQueryFunction = (
  id: string,
): Promise<DamagesInformationQuery[]> =>
  fetchApi.get(`/file_information/${id}/damages_information/`);
